import { analyticsConstants } from '@constants/analytics';

const conversionTotalPrototype = {
    id: 'Overall',
    sentSurveys: 0,
    sentSurveysPercent: 100,
    invitesSentPercent: 100,
    responsesReceived: 0,
    responsesReceivedPercent: 0,
    leaveReviewClicked: 0,
    leaveReviewClickedPercent: 0,
    openedSurveys: 0,
    openedSurveysPercent: 0,
    reviewsReceived: 0,
    reviewsReceivedPercent: 0,
};

const initialState = {
    conversionLoading: false,
    surveysTableData: [],
    qrTableData: [],
    conversionTrendData: [],
    total: {
        responseRate: '0.00',
        responseRateDelta: '0.00',
        reviewRate: '0.00',
        reviewRateDelta: '0.00',
        openedSurveys: 0,
        openedSurveysPercentage: 0,
        responsesReceived: 0,
        responsesReceivedPercentage: 0,
        leaveReviewClicked: 0,
        leaveReviewClickedPercentage: 0,
        reviewsReceived: 0,
        reviewsReceivedPercentage: 0,
        surveys: { ...conversionTotalPrototype },
        qr: { ...conversionTotalPrototype },
    },
    conversionError: null,
    reviewsLoading: false,
    reviewsData: {
        tableData: [],
        overall: {
            averageRatingDelta: '0.00',
            averageRating: '0.00',
            totalReviewsDelta: '0.00',
            totalReviews: 0,
            replyRate: null,
            replyRateDelta: null,
            reviewIndex: null,
            reviewIndexDelta: null,
            ratingDistributions: [],
        },
        channelData: [],
        sentimentData: [],
        ratingsTimeline: [],
        dayOfWeekDistribution: [],
        daypartDistribution: [],
    },
    reviewsError: null,
    feedbackLoading: false,
    feedbackData: {
        tableData: [],
        overall: {
            averageRatingDelta: '0.00',
            averageRating: '0.00',
            totalResponsesDelta: '0.00',
            totalResponses: 0,
            netPromoterScore: 0,
            netPromoterScoreDelta: '0.00',
            negativeResponses: 0,
            negativeResponsesDelta: '0.00',
            ratingDistributions: [],
        },
        sentimentData: [],
        npsData: [],
        answersData: {},
        questionDistributions: {},
    },
    feedbackError: null,
    conversationsLoading: true,
    conversationsData: {
        tableData: [],
        trendData: [],
        rates: {
            closedConversationsCount: 0,
            closedConversationsCountDelta: 0,
            conversationsCount: 0,
            conversationsCountDelta: 0,
            openConversationsCount: 0,
            resolutionRate: 0,
            resolutionRateDelta: 0,
            resolutionTime: 0,
            resolutionTimeDelta: 0,
            responseRate: 0,
            responseRateDelta: 0,
            responseTime: 0,
            responseTimeDelta: 0,
            averageMessagesCount: 0,
            averageMessagesCountDelta: 0,
            unassignedConversationsCount: 0,
            channelsBreakdown: [],
        },
    },
    conversationsError: null,
    socialPostsLoading: true,
    socialPostsData: {
        reach28TrendData: [],
        followersTrendData: [],
        engagementsTrendData: [],
        tableData: [],
        rates: {
            posts: 0,
            postsDelta: '0.00',
            followers: null,
            followersDelta: null,
            reach28: null,
            reach28Delta: null,
            rateByReach: null,
            rateByReachDelta: null,
            rateByFollowers: null,
            rateByFollowersDelta: null,
            reach: 0,
            reachDelta: '0.00',
            likes: 0,
            likesDelta: '0.00',
            comments: 0,
            commentsDelta: '0.00',
            shares: 0,
            sharesDelta: '0.00',
        },
    },
    socialPostsError: null,
    presenceLoading: true,
    presenceData: {
        keywords: [],
        devicesDistribution: {
            googleMapsDesktop: 0,
            googleMapsDesktopPercentage: 0.0,
            googleMapsMobile: 0,
            googleMapsMobilePercentage: 0.0,
            googleSearchDesktop: 0,
            googleSearchDesktopPercentage: 0.0,
            googleSearchMobile: 0,
            googleSearchMobilePercentage: 0.0,
        },
        locationsDistribution: [],
        engagementsDistribution: [],
        viewsDistribution: [],
        rates: {
            searchAppearance: 0,
            searchAppearanceChange: 0,
            views: 0,
            viewsChange: 0,
            engagements: 0,
            engagementsChange: 0,
            conversion: 0,
            conversionChange: 0,
        },
    },
    presenceError: null,
    operationalInsightsLoading: false,
    operationalInsightsData: {
        topStrengths: [],
        topIssues: [],
        categories: [],
        locationRows: [],
    },
    operationalInsightsError: null,
    visibilitySummaryLoading: false,
    visibilitySummary: null,
    visibilitySummaryError: null,
    visibilityLocationsLoading: false,
    visibilityLocations: {
        items: [],
        totalCount: 0,
        pages: 0,
        page: 0,
        pageSize: 10,
    },
    visibilityLocationsError: null,
    visibilityDetailLoading: false,
    visibilityDetail: null,
    visibilityDetailError: null,
};

export function analytics(state = initialState, action) {
    switch (action.type) {
        case analyticsConstants.ANALYTICS_CONVERSION_REQUEST:
            return { ...state, conversionLoading: true };
        case analyticsConstants.ANALYTICS_CONVERSION_SUCCESS:
            return {
                ...state,
                conversionLoading: false,
                surveysTableData: action.payload.surveysTableData,
                qrTableData: action.payload.qrTableData,
                conversionTrendData: action.payload.trendData || [],
                total: action.payload.total,
                conversionResponseRate: action.payload.responseRate,
                conversionResponseRateDelta: action.payload.responseRateDelta,
                conversionReviewRate: action.payload.reviewRate,
                conversionReviewRateDelta: action.payload.reviewRateDelta,
            };
        case analyticsConstants.ANALYTICS_CONVERSION_FAILURE:
            return { ...state, conversionLoading: false, conversionError: action.payload };
        case analyticsConstants.ANALYTICS_REVIEWS_REQUEST:
            return { ...state, reviewsLoading: true };
        case analyticsConstants.ANALYTICS_REVIEWS_SUCCESS:
            return { ...state, reviewsLoading: false, reviewsData: action.payload };
        case analyticsConstants.ANALYTICS_REVIEWS_FAILURE:
            return { ...state, reviewsLoading: false, reviewsError: action.payload };
        case analyticsConstants.ANALYTICS_FEEDBACK_REQUEST:
            return { ...state, feedbackLoading: true };
        case analyticsConstants.ANALYTICS_FEEDBACK_SUCCESS:
            return { ...state, feedbackLoading: false, feedbackData: action.payload };
        case analyticsConstants.ANALYTICS_FEEDBACK_FAILURE:
            return { ...state, feedbackLoading: false, feedbackError: action.payload };
        case analyticsConstants.ANALYTICS_CONVERSATIONS_SUCCESS:
            return { ...state, conversationsLoading: false, conversationsData: action.payload };
        case analyticsConstants.ANALYTICS_CONVERSATIONS_FAILURE:
            return { ...state, conversationsLoading: false, conversationsError: action.payload };
        case analyticsConstants.ANALYTICS_SOCIAL_POSTS_REQUEST:
            return { ...state, socialPostsLoading: true };
        case analyticsConstants.ANALYTICS_SOCIAL_POSTS_SUCCESS:
            return { ...state, socialPostsLoading: false, socialPostsData: action.payload };
        case analyticsConstants.ANALYTICS_SOCIAL_POSTS_FAILURE:
            return { ...state, socialPostsLoading: false, socialPostsError: action.payload };
        case analyticsConstants.ANALYTICS_PRESENCE_REQUEST:
            return { ...state, presenceLoading: true };
        case analyticsConstants.ANALYTICS_PRESENCE_SUCCESS:
            return { ...state, presenceLoading: false, presenceData: action.payload };
        case analyticsConstants.ANALYTICS_PRESENCE_FAILURE:
            return { ...state, presenceLoading: false, presenceError: action.payload };
        case analyticsConstants.ANALYTICS_OPERATIONAL_INSIGHTS_REQUEST:
            return { ...state, operationalInsightsLoading: true };
        case analyticsConstants.ANALYTICS_OPERATIONAL_INSIGHTS_SUCCESS:
            return { ...state, operationalInsightsLoading: false, operationalInsightsData: action.payload };
        case analyticsConstants.ANALYTICS_OPERATIONAL_INSIGHTS_FAILURE:
            return { ...state, operationalInsightsLoading: false, operationalInsightsError: action.payload };
        case analyticsConstants.ANALYTICS_VISIBILITY_SUMMARY_REQUEST:
            // Clear the prior error on each new request so a successful retry isn't masked
            // by a stale failure.
            return { ...state, visibilitySummaryLoading: true, visibilitySummaryError: null };
        case analyticsConstants.ANALYTICS_VISIBILITY_SUMMARY_SUCCESS:
            return {
                ...state,
                visibilitySummaryLoading: false,
                visibilitySummary: action.payload,
                visibilitySummaryError: null,
            };
        case analyticsConstants.ANALYTICS_VISIBILITY_SUMMARY_FAILURE:
            return {
                ...state,
                visibilitySummaryLoading: false,
                visibilitySummary: null,
                visibilitySummaryError: action.payload,
            };
        case analyticsConstants.ANALYTICS_VISIBILITY_LOCATIONS_REQUEST:
            return { ...state, visibilityLocationsLoading: true, visibilityLocationsError: null };
        case analyticsConstants.ANALYTICS_VISIBILITY_LOCATIONS_SUCCESS:
            return {
                ...state,
                visibilityLocationsLoading: false,
                visibilityLocations: action.payload,
                visibilityLocationsError: null,
            };
        case analyticsConstants.ANALYTICS_VISIBILITY_LOCATIONS_FAILURE:
            return {
                ...state,
                visibilityLocationsLoading: false,
                visibilityLocations: initialState.visibilityLocations,
                visibilityLocationsError: action.payload,
            };
        case analyticsConstants.ANALYTICS_VISIBILITY_AUTOSCAN_SET:
            return {
                ...state,
                visibilityLocations: {
                    ...state.visibilityLocations,
                    items: (state.visibilityLocations.items || []).map(item =>
                        item.locationId === action.payload.locationId
                            ? { ...item, autoScanEnabled: action.payload.enabled }
                            : item,
                    ),
                },
            };
        case analyticsConstants.ANALYTICS_VISIBILITY_DETAIL_REQUEST:
            return { ...state, visibilityDetailLoading: true, visibilityDetail: null, visibilityDetailError: null };
        case analyticsConstants.ANALYTICS_VISIBILITY_DETAIL_SUCCESS:
            return {
                ...state,
                visibilityDetailLoading: false,
                visibilityDetail: action.payload,
                visibilityDetailError: null,
            };
        case analyticsConstants.ANALYTICS_VISIBILITY_DETAIL_FAILURE:
            return {
                ...state,
                visibilityDetailLoading: false,
                visibilityDetail: null,
                visibilityDetailError: action.payload,
            };
        default:
            return state;
    }
}
